// Imports => Constants
import { ENDPOINTS } from '@constants';

export class SettingsApi {
  constructor(Client, NoBaseClient, config) {
    this.Client = Client;
    this.config = config;
  }

  get = (params) => {
    return this.Client.get(`${ENDPOINTS.SETTINGS.GET}`, { params }).then(
      (response) => response.data.data
    );
  };
}

export default SettingsApi;
